import { useMutation, useQueryClient } from "react-query";
import { loggedInApiCall } from "src/api/axiosClient/userApi";
import { getAllSaml2ProvidersKey, SAML2_PROVIDERS_ENDPOINT } from "./useGetAllSaml2Providers";

type UpsertSaml2ProviderOptions = {
    id?: number;
    payload: Record<string, unknown>;
};

export const useUpsertSaml2Provider = () => {
    const queryClient = useQueryClient();

    const query = useMutation({
        mutationFn: async ({ id, payload }: UpsertSaml2ProviderOptions) => {
            if (id === undefined) {
                return loggedInApiCall.post(SAML2_PROVIDERS_ENDPOINT, payload);
            }

            return loggedInApiCall.patch(`${SAML2_PROVIDERS_ENDPOINT}/${id}`, payload, {
                headers: { "Content-Type": "application/merge-patch+json" },
            });
        },
        onSuccess: () => queryClient.invalidateQueries([getAllSaml2ProvidersKey]),
    });

    return query;
};
